import * as React from 'react';
import { LibraryCard, CardType, CardPropertyType, CardProperties } from '../../../../types/LibraryCard';
import Button from '../../../Button/Button';
import './QuickButton.css';
import { setBookProperties } from '../../../../store/calendar/actions';
import { connect } from 'react-redux';
import saveCardProperties from '../../../../requests/saveCardProperties';

interface Props {
	libraryCard: LibraryCard;
	onClick?: (type: CardType) => void;
}

interface DispatchProps {
	setBookProperties: typeof setBookProperties;
}

const QuickButton: React.FunctionComponent<Props & DispatchProps> = props => {
	const [loading, setLoading] = React.useState(false);

	const buttonText = React.useMemo(() => {
		switch (props.libraryCard.cardType) {
			case CardType.ReadNow:
				return "✅ Прочитано";
			
			case CardType.WantRead:
				return "▶ В список Читаю сейчас";
			
			case CardType.AlreadyRead:
				return '🕑 Запланировать к чтению';
		}
	}, [props.libraryCard]);

	const onClick = () => {
		if (props.libraryCard.cardType === CardType.WantRead) {
			props.onClick(CardType.ReadNow);
		}
		else if (props.libraryCard.cardType === CardType.ReadNow) {
			props.onClick(CardType.AlreadyRead)
		}
		else if (props.libraryCard.cardType === CardType.AlreadyRead) {
			props.onClick(CardType.WantRead)
		}
	};

	return <Button className='quickButton' onClick={onClick} isLoading={loading}>
		{buttonText}
	</Button>;
};

export default connect(() => { }, {
	setBookProperties: setBookProperties
})(QuickButton);
